<template>
  <div v-if="showTime" class="time">
    <div class="time-item">
      <!-- {{ showTime }} -->
      {{ time }}
    </div>
  </div>
</template>

<script>
import { caculateTimeago } from '@/timpackage/utils/imListTime'
export default {
  name: 'imSystem',
  props: {
    message: {
      type: Object,
      default() {
        return {
          payload: {}
        }
      }
    }
  },
  data() {
    return {}
  },
  computed: {
    time() {
      return caculateTimeago(this.message.time * 1000)
    },
    showTime() {
      // return caculateTimeago(this.message.time * 1000)
      return this.message.showTime
    }
  }
}
</script>

<style lang="scss" scoped>
.time {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0.426667rem 0;
  .time-item {
    display: inline-block;
    padding: 0.213333rem 0.426667rem;
    font-size: 0.512rem;
    line-height: 0.512rem;
    font-weight: 400;
    color: #888888;
  }
}
</style>
